const N = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNDE0IDEybDYuMzY0IDYuMzY0LTEuNDE0IDEuNDE0TDEyIDEzLjQxNGwtNi4zNjQgNi4zNjQtMS40MTQtMS40MTRMMTAuNTg2IDEyIDQuMjIyIDUuNjM2bDEuNDE0LTEuNDE0TDEyIDEwLjU4Nmw2LjM2NC02LjM2NCAxLjQxNCAxLjQxNHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPgo=";
export {
  N as default
};
//# sourceMappingURL=close-dd0c561a.mjs.map
